import { render, staticRenderFns } from "./CallRatingDetailsModal.vue?vue&type=template&id=f922e248"
import script from "./CallRatingDetailsModal.vue?vue&type=script&lang=js"
export * from "./CallRatingDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports